$('[data-toggle-classes]').click(event => {
    const $toggledElem = $(event.currentTarget);
    const toggledElems = $toggledElem.data('toggleClasses').split(';');
    toggledElems.forEach(elem => {
        let $elem = $(elem);
        if (! $elem.data('toggleClassesDisabled')) {
            $elem.toggleClass($elem.data('toggledClasses'));
        }
    });
});
